<template>
  <div>
    <div v-if="isPC" class="flash-sale">
      <div class="flash-sale-nav">
        <el-image :src="topBannerPc" style="width:100%;border-radius: 12px"></el-image>
      </div>
      <h3>{{ $t('Index.Components.FlashSale.EndsIn') }}</h3>
      <div class="time f-c-c">
        <Time :deadline="+saleEndTime" />
      </div>
      <div class="product-filter f-e-c">
        <el-select v-model="flashSaleForm.countryCodeArray" multiple collapse-tags :placeholder="$t('inSrock.shippingFrom')" @change="resetPage">
          <el-option v-for="item in shippingFromList" :key="item.countryCode" :label="item.countryCn" :value="item.countryCode"></el-option>
        </el-select>
        <Sort style="margin-left: 15px;" @change="sortChange"></Sort>
      </div>
      <div class="product-list f fw-w " v-loading="listLoading">
        <Product v-for="item in saleProductList" :key="item.kkProductId" :product="item" class="product-item" :isShowProgress="true" kklocation="flashSaleList" reportType="activity"></Product>
      </div>
      <div v-if="!saleProductList.length && !listLoading" class="empty">
        <div class="f-c-c fd-c">
          <img src="@/assets/img/activity_empty.svg" alt="">
          <p>{{ $t('Index.Components.FlashSale.EventExpried') }}</p>
        </div>
      </div>
      <el-button v-if="showMore" class="more f-c-c pointer" :loading="listLoading" @click="handleMore">
        <div>{{ $t('Index.Components.FlashSale.ViewMore') }}</div>
        <i class="iconfont icon-jiantou-xuanze" />
      </el-button>
    </div>
    <div v-else class="mobile-flash">
      <!-- <h3>Ends In</h3> -->
      <div class="mobile-time f--c f-e">
        <Time :deadline="+saleEndTime" />
      </div>
      <div style="padding: 0.2rem 0.3rem;">
        <div :class="[fixFilter?'fix-filter':'']">
          <van-dropdown-menu>
            <van-dropdown-item v-model="mobileShipFrom" title="Ship From">
              <van-cell center :title="item.countryCn" v-for="item in shippingFromList" :class="[item.checked?'checked-country':'']" :key="item.countryCn" @click="shipFromChangeMobile(item)">
                <template #right-icon>
                  <i class="el-icon-check" v-if="item.checked"></i>
                </template>
              </van-cell>
            </van-dropdown-item>
            <van-dropdown-item :options="sortListForMobile" @change="value => sortChangeMobile(value)" v-model="sortKeyForMobile"></van-dropdown-item>
          </van-dropdown-menu>
        </div>
        <div class="product-list f-b-c fw-w " v-loading="listLoading">
          <Product v-for="item in saleProductList" :key="item.kkProductId" :product="item" class="product-item" :isShowProgress="true" kklocation="flashSaleList" reportType="activity"></Product>
        </div>
        <div v-if="!saleProductList.length && !listLoading" class="empty">
          <div class="f-c-c fd-c">
            <img src="@/assets/img/activity_empty.svg" alt="">
            <p>{{ $t('Index.Components.FlashSale.EventExpried') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 返回顶部 -->
    <el-backtop :bottom="190" :right="6" class="backtop">
      <img style="width:70px;height:70px" src="@/assets/img/homePage/backtop.png" alt="" />
    </el-backtop>
  </div>
</template>

<script>
import API from '@/api'
import Sort from '@/views/commodity/components/Sort.vue'
import Time from '@/views/index/components/Time.vue'
import Product from '@/components/Product.vue'
import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import cell from 'vant/lib/cell'
import 'vant/lib/cell/style'
import 'vant/lib/icon/style'
import getSortOptions from '@/config/sortOptions.js'
export default {
  components: {
    Time,
    Sort,
    Product,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-cell': cell

  },
  data() {
    return {
      listLoading: false,
      flashSaleForm: {
        pageNumber: 1,
        pageSize: 20
      },
      fixFilter: false,
      filterVisible: false,
      filterState: '',
      total: 0,
      isBottom: false,
      shippingFromList: [],
      mobileShipFrom: [],
      saleProductList: [],
      saleEndTime: '', // 截止时间
      totalPage: undefined,
      countryCodeArrayMobile: 'US',
      sortKeyForMobile: 1,
      discountId: undefined,
      topBannerPc: ''
    }
  },
  computed: {
    showMore() {
      return this.saleProductList.length < this.total
    },
    sortListForMobile() {
      const arr = getSortOptions.call(this)
      arr.forEach(e => {
        e.text = e.name
        e.value = e.key
      })
      return arr
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.scroll)
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll)
  },
  created() {
    this.getShippingFromList()
    this.getDiscountProductList()
    this.discountId = this.$route.query.discountId
    this.getDiscountConfig(this.discountId)
  },
  methods: {

    // 秒杀产品
    getDiscountProductList() {
      this.isBottom = false
      this.listLoading = true
      this.flashSaleForm.discountId = this.$route.query.discountId
      if (!this.isPC) { this.flashSaleForm.countryCodeArray = this.getCountryCodeArray() }
      API.getDiscountProductList(this.flashSaleForm).then(({ data }) => {
        this.saleProductList = this.flashSaleForm.pageNumber === 1 ? data.list : [...this.saleProductList, ...data.list]
        this.total = data.total
        this.totalPage = Math.ceil(this.total / this.flashSaleForm.pageSize)
        this.saleEndTime = data.list.length && data.list[0].endTime
      }).finally(() => {
        this.listLoading = false
      })
    },

    scroll() {
      if (this.isPC) {
        return
      }
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop > 50) {
        this.fixFilter = true
      } else {
        this.fixFilter = false
      }
      if (scrollTop + windowHeight - scrollHeight > -200 && !this.listLoading && this.flashSaleForm.pageNumber < this.totalPage) {
        this.flashSaleForm.pageNumber++
        this.getDiscountProductList()
      }
    },

    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重
        const map = {}
        result.data.list.forEach(item => {
          if (['CN_N', 'CN_S'].includes(item.countryCode)) {
            map['CN'] = {
              countryCn: 'China',
              countryCode: 'CN'
            }
            return
          }
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromList = Object.values(map)
      })
    },

    resetPageCountryMobile() {
      this.$refs.countryItem.toggle()
    },

    resetPage() {
      this.flashSaleForm.pageNumber = 1
      this.getDiscountProductList()
    },

    sortChange(sortName, sortType) {
      this.filterVisible = false
      this.flashSaleForm.sortName = sortName
      this.flashSaleForm.sortType = sortType // sortType === 'asc' ? 2 : 1
      this.resetPage()
    },

    handleMore() {
      if (!this.showMore) return
      ++this.flashSaleForm.pageNumber
      this.getDiscountProductList()
    },

    showFilter(state) {
      this.filterVisible = true
      this.filterState = state
    },

    mobileClickShipForm(countryCode) {
      this.filterVisible = false
      let countryCodeArray = this.flashSaleForm.countryCodeArray
      if (Array.isArray(countryCodeArray)) {
        countryCodeArray.includes(countryCode) ? countryCodeArray.splice(countryCodeArray.indexOf(countryCode), 1) : countryCodeArray.push(countryCode)
      } else {
        countryCodeArray = []
        countryCodeArray.push(countryCode)
      }
      this.$set(this.flashSaleForm, 'countryCodeArray', countryCodeArray.length > 0 ? countryCodeArray : undefined)
      this.resetPage()
    },
    shipFromChangeMobile(value) {
      this.$set(value, 'checked', !value.checked)
      this.resetPage()
    },
    getCountryCodeArray() {
      let countryCodeArray = this.shippingFromList.filter(e => e.checked).map(e => e.countryCode)
      return countryCodeArray.length ? countryCodeArray : undefined
    },
    sortChangeMobile(value) {
      const { sortName, sortType } = this.sortListForMobile.find(e => e.value === value)
      this.sortChange(sortName, sortType)
    },
    getDiscountConfig(discountId) {
      API.getDiscountConfig({ discountId }).then(res => {
        this.topBannerPc = res.data.bannerImgurl
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flash-sale {
  max-width: 1400px;
  position: relative;
  margin: 0 auto;
  padding-bottom: 50px;
  h3 {
    font-family: 'Poppins';
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    text-align: center;
    color: #000000;
  }
  .empty {
    padding: 20px;
    p {
      margin-top: 20px;
    }
  }
}
.product-item {
  width: 19%;
  margin: 0 0.5% 20px;
}
.product-filter {
  margin-bottom: 15px;
}
.time-bar {
  width: 34px;
  height: 41px;
  background: #000000;
  border-radius: 2px;
  margin-right: 1px;
  color: #fff;
  font-size: 30px;
  font-weight: 600px;
  line-height: 40px;
  text-align: center;
}
i {
  font-size: 20px;
  font-weight: 500;
}
.time {
  padding: 26px 0;
}
.mobile-time {
  padding: 0 10px 10px 0;
  background: url('https://img.kakaclo.com/web-img/index/Group%202246.png') no-repeat;
  // height: 60px;
  background-size: 100%;
}
.flash-sale-nav {
  margin: 15px auto;
  max-width: 1400px;
  padding: 22px 0;
  h2 {
    font-weight: 600;
    font-size: 30px;
    line-height: 45px;
    text-align: center;
    color: #ffffff;
    text-align: center;
  }
}
.more {
  width: 152px;
  height: 42px;
  border-radius: 42px;
  border: 1px solid #cdd4dd;
  font-size: 16px;
  margin: 10px auto;
  background-color: #fff;

  display: flex;

  /deep/ span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  i {
    color: #8b93a3;
    margin-left: 10px;
  }
}
.mobile-flash {
  h3 {
    text-align: center;
  }
  background: #fff;
  // padding: 0.2rem 0.3rem;
  .product-item {
    width: 48%;
    margin-bottom: 0.08rem;
  }
  /deep/ .time-comp {
      .block {
        width: .4rem;
        height: .48rem;
        font-size: .3rem;
        line-height: .48rem;
      }
    }
  .empty {
    padding: 20px;
    img {
      width: 60%;
    }
    p {
      margin-top: 20px;
    }
  }
}
.shipping-from-item-actived {
  color: #99c41c!important;
  background: rgba(153, 196, 28, 0.04);
}
.shipping-from-item {
  padding: 0 0.4rem;
  line-height: 1.2rem;
  border-bottom: solid 1px rgba(0, 0, 0, 0.04);
}
/deep/.van-dropdown-menu__bar{
  box-shadow: none;
}
/deep/ .van-dropdown-item__option--active {
    color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
/deep/.van-dropdown-item__icon{
  color: #99C41C;
}

/deep/.van-dropdown-menu__title--active {
   color: #99C41C;
}
/deep/.van-cell .van-cell--center{
  color: #99C41C;
}

/deep/.el-icon-check{
  color: #99C41C;
}
.checked-country{
  color: #99C41C;
   background: rgba(153, 196, 28, 0.04);
}
.fix-filter{
  width: 100%;
  // height: 40px;
  background: #fff;
  position: fixed;
  top: 0.85rem;
  left: 0;
  z-index: 10;
  padding:0 0.3rem;
}
</style>
